<template>
  <q-page class="q-pa-md row q-gutter-md content-start justify-center">
    <template v-if="finalNewsItems.length === 0">
      <div class="col text-center text-h5 q-mt-md">
        No news is good news!
      </div>
    </template>
    <template v-else>
      <q-card
        v-for="newsItem in finalNewsItems"
        :key="newsItem.id"
        class="column"
        :class="{ 'cursor-pointer': newsItem.hasAction }"
        style="width: 400px; max-width: 500px; flex-grow: 1; flex-shrink: 1;"
        flat
        bordered
        @click="handleClick(newsItem)"
      >
        <q-img
          :src="newsItem.imageUrl"
        />

        <q-card-section>
          <div class="text-h6">
            {{ newsItem.title }}
          </div>
          <div class="text-subtitle2">
            {{ newsItem.description }}
          </div>
        </q-card-section>

        <q-space />

        <q-card-section
          v-if="newsItem.hasAction && newsItem.buttonText"
          class="q-pt-none text-center"
        >
          <q-btn
            flat
            outlined
            @click="handleClick(newsItem)"
          >
            {{ newsItem.buttonText }}
          </q-btn>
        </q-card-section>
      </q-card>
    </template>
  </q-page>
</template>

<script>

export default {
  name: 'News',
  configuration: ['publishedNewsItems'],
  props: {
    demoNewsItems: {
      type: Array,
      required: false,
      default: null
    },
    admin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    finalNewsItems () {
      return this.demoNewsItems || _.filter(this.publishedNewsItems.data, 'visible')
    }
  },
  methods: {
    handleClick (newsItem) {
      if (!newsItem || !newsItem.hasAction) return

      this.$trackEvent(this.$customerEvents.CLICKED_NEWS_ITEM, { id: newsItem.id, title: newsItem.title })

      newsItem.route(this.$router)
    }
  },
  trackPage: true
}
</script>
